import { render, staticRenderFns } from "./SkeletonCurrentBonusCard.vue?vue&type=template&id=4db2a954&"
import script from "./SkeletonCurrentBonusCard.vue?vue&type=script&lang=js&"
export * from "./SkeletonCurrentBonusCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports